import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function TokenStep(props) {
  const { handleChange, onConfirmToken, isVerifying, token_destination, mask_number, sendToken } = props;

  return (
    <div className="max-w-md mx-auto space-y-6 bg-white p-8 border border-gray-100 rounded-2xl shadow-sm text-center">
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
        <svg className="w-8 h-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
      </div>
      <h2 className="text-2xl font-bold text-slate-900">Verify Identity</h2>
      <p className="text-slate-600">A secure token has been sent to <br/><strong className="text-slate-900 text-lg tracking-wide">{mask_number(token_destination)}</strong></p>
      
      <div className="text-left mt-6">
        <label className={formStyles.label}>Verification Token</label>
        <input name="token" type="text" onChange={handleChange} className={`${formStyles.input} text-center tracking-[0.5em] text-2xl font-mono`} placeholder="••••••" />
      </div>

      <button onClick={onConfirmToken} className={`${formStyles.buttonPrimary} w-full mt-6`}>
        Verify Token {isVerifying && <span className="ml-2"><Loader /></span>}
      </button>
      
      <button type="button" onClick={() => sendToken("voice", token_destination)} className="text-sm font-semibold text-slate-500 hover:text-slate-900 underline mt-4 inline-block">
        Didn't receive code? Resend via Voice
      </button>
    </div>
  );
}